import { render, staticRenderFns } from "./Learners.vue?vue&type=template&id=3ea0af4a&scoped=true&"
import script from "./Learners.vue?vue&type=script&lang=js&"
export * from "./Learners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea0af4a",
  null
  
)

export default component.exports